const defaultState = {
  brand: 'vw',
  style: 'blue',
  brand_id: 1,
  legacy_service_option: false,
};

// nissan red
// gm yellow
// vw blue

export default function models(state = defaultState, action) {
  switch (action.type) {
    case 'CONFIGURATION_UPDATED':
      return Object.assign({}, state, action.newConfig);

    default:
      return state;
  }
}
